import debounce from "lodash-es/debounce"

$(() => {
  if (!$("[data-roadmap]").length === 0) return

  const $past = $("[data-roadmap=past]")
  const $present = $("[data-roadmap=present]")

  const drawGrid = () => {
    const $windowWidth = $(window).width()

    if ($windowWidth > 768) {
      const $roadmapItem = $("[data-roadmap]")
      $roadmapItem.each((i, el) => {
        const $self = $(el)
        const $line = $self.find("[data-roadmap-grid-line]")
        const $elClassName = $line.get(0).className
        const $animLine = $self.find("[data-roadmap-line]")

        $animLine.removeClass("_left _right _middle")

        if ($windowWidth < 1024) {
          if (/md-left/.test($elClassName)) {
            $animLine.addClass("_left")

            if ($self.data("roadmap") === "present") {
              $animLine.attr("data-roadmap-line", "left-present")
            } else {
              $animLine.attr("data-roadmap-line", "left")
            }
          }

          if (/md-middle/.test($elClassName)) {
            $animLine.addClass("_middle").attr("data-roadmap-line", "middle")
          }

          if (/md-right/.test($elClassName)) {
            $animLine.addClass("_right").attr("data-roadmap-line", "right")
          }
        } else {
          if (/lg-left/.test($elClassName)) {
            $animLine.addClass("_left")

            if ($self.data("roadmap") === "present") {
              $animLine.attr("data-roadmap-line", "left-present")
            } else {
              $animLine.attr("data-roadmap-line", "left")
            }
          }

          if (/lg-middle/.test($elClassName)) {
            $animLine.addClass("_middle").attr("data-roadmap-line", "middle")
          }

          if (/lg-right/.test($elClassName)) {
            $animLine.addClass("_right").attr("data-roadmap-line", "right")
          }
        }
      })

      const $containerOffsetLeft = $("[data-roadmap-container]").offset().left
      const $lines = $("[data-roadmap-line]")
      const $lineFirst = $("[data-roadmap-line=first]")
      const $lineLeft = $("[data-roadmap-line=left]")
      const $lineLeftPresent = $("[data-roadmap-line=left-present]")
      const $lineMiddle = $("[data-roadmap-line=middle]")
      const $lineRight = $("[data-roadmap-line=right]")
      const $linesLength = $lines.length
      const delay = 0.5 * $linesLength * 1000

      $present.find("[data-roadmap-title]").css("transition-delay", delay + "ms")

      $lines.each((i, el) => {
        $(el)
          .css("transition-delay", 0.5 * (i + 1) + "s")
          .siblings("[data-roadmap-circle]")
          .css("transition-delay", 0.5 * (i + 1) + "s")
      })

      $lineFirst.css("width", "100%")
      $lineLeft.each((i, el) => {
        $(el).css({
          width: "calc(110% + " + $containerOffsetLeft + "px)",
          left: "-" + $containerOffsetLeft + "px",
        })
      })
      $lineLeftPresent
        .css({
          width: $containerOffsetLeft + 25 + "px",
          left: "-" + ($containerOffsetLeft + 5) + "px",
        })
        .siblings("[data-roadmap-circle], [data-roadmap-title]")
        .css("transition-delay", delay + 500 + "ms")
      $lineMiddle.css({ width: "100%" })
      $lineRight.css({ left: "", width: "calc(100% + " + $containerOffsetLeft + "px)" })

      $past.addClass("_past")
      $present.addClass("_present")
    } else {
      $past.addClass("_past")
      $present.addClass("_present")
    }
  }

  $(document).on("scroll:roadmap", () => drawGrid())

  $(window).on("resize", debounce(drawGrid, 100, { trailing: true, leading: false }))
})



// WEBPACK FOOTER //
// ./src/blocks/12.roadmap/roadmap.js